<template>
  <div>
    <div class="bg-white pb-10 rounded-lg">
      <h1 class="main-text">Get a Quote</h1>
      <p class="text-center py-3">
        Enter your details below to get a quick shipment quote
      </p>

      <div
        class="mt-4 p-3 shadow-md m-3 flex justify-between flex-wrap rounded-lg"
      >
        <p class="py-3 w-full">Ship From</p>

        <div class="w-5/12">
          <label class="label">Country</label>
          <el-select
            filterable
            v-model="payload.shipperLocation.country"
            placeholder="Select country"
          >
            <el-option
              v-for="country in countries"
              :key="country"
              :label="country"
              :value="country"
            >
            </el-option>
          </el-select>
        </div>

        <div class="w-5/12">
          <label class="label">Address</label>
          <!-- <auto-complete :customStyle="customAltStyle" :locationDetails="getAddressFrom" placeholder="Enter Address"/> -->
           <Addressinput class="address_input" placeholder="--Enter Address--" :locationDetails="getAddressFrom" />
        </div>

        <p class="py-3 w-full">Ship To</p>

        <div class="w-5/12">
          <label class="label">Country</label>
          <el-select
            filterable
            v-model="payload.consigneeLocation.country"
            placeholder="Select country"
          >
            <el-option
              v-for="country in countries"
              :key="country"
              :label="country"
              :value="country"
            >
            </el-option>
          </el-select>
        </div>

        <div class="w-5/12">
          <label class="label">Address</label>
          <!-- <auto-complete :customStyle="customAltStyle" :locationDetails="getAddressTo" placeholder="Enter Address"/> -->
           <Addressinput class="address_input" placeholder="--Enter Address--" :locationDetails="getAddressTo" />
        </div>

        <div class="flex items-center w-full py-12">
          <div class="w-6/12">
            <button @click="$router.go(-1)">Cancel</button>
          </div>
          <div class="w-6/12 flex justify-end">
            <button
              class="primary-button"
              :disabled="isDisable"
              :class="[isDisable ? 'opacity-50' : 'opacity-100']"
              @click="navigate"
            >
              Describe Your Shipment
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Addressinput from "../UI/Addressinput.vue"

export default {
  components: { Addressinput },
  watch: {},
  computed: {
    customAltStyle(){
       return {
        width: '100%',
        padding: '8px 10px',
        borderRadius: '5px',
        border: '1px solid rgb(220,216,223)'
       }
    },
    isDisable() {
      return (
        !this.payload.consigneeLocation?.country ||
        !this.payload.shipperLocation?.country ||
        !this.payload.shipperLocation?.address?.lat ||
        !this.payload.consigneeLocation?.address?.lat
      );
    },
  },
  data() {
    return {
      setAddressConsign: {},
      payload: {
        userId: localStorage.getItem("userId"),
        consigneeLocation: {
          country: "",
          address: {
            lat: null,
            lng: null,
            name: "",
          },
        },
        shipperLocation: {
          country: "",
          address: {
            lat: null,
            lng: null,
            name: "",
          },
        },
      },
      countries: ["Nigeria"],
    };
  },
  methods: {
    navigate() {
      localStorage.setItem("quote-darft-flow", JSON.stringify(this.payload));
      this.$emit("changeTabs", "describe-shipping");
    },
    getAddressTo(addressData) {
      let address = {
        name: addressData?.name,
        lat: addressData?.lat,
        lng: addressData?.lng,
      };
      this.payload.consigneeLocation.address = address;
    },
    getAddressFrom(addressData) {
      let address = {
        name: addressData?.name,
        lat: addressData?.lat,
        lng: addressData?.lng,
      };
      this.payload.shipperLocation.address = address;
    },
  },
};
</script>

<style lang="scss" scoped>
.main-text {
  font-size: 27px;
  @apply py-4 text-center pt-12;
}
.primary-button {
  @apply px-5 bg-primary-yellow py-3 rounded-md;
}
</style>
